import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { Dashboard } from './pages/Dashboard';
import { Login } from './pages/Login';
import { NotFound } from './pages/NotFound';
import { BlockchainDeposits } from './pages/deposits/BlockchainDeposits';
import { DepositList } from './pages/deposits/DepositList';
import { DappRequests } from './pages/dapp-requests/DappRequests';
import { IncomeLedger } from './pages/income/IncomeLedger';
import { MemberDetail } from './pages/members/MemberDetail';
import { MemberList } from './pages/members/MemberList';
import { MemberSearch } from './pages/members/MemberSearch';
import { VirtualPower } from './pages/members/VirtualPower';
import { WalletAdjust } from './pages/members/WalletAdjust';
import { PackageManagement } from './pages/packages/PackageManagement';
import { TicketDetail } from './pages/support/TicketDetail';
import { TicketList } from './pages/support/TicketList';
import { CronMonitor } from './pages/system/CronMonitor';
import { News } from './pages/system/News';
import { SystemSettings } from './pages/system/SystemSettings';
import { BinaryTree } from './pages/team/BinaryTree';
import { AutoWithdrawal } from './pages/withdrawals/AutoWithdrawal';
import { Lds1Purchase } from './pages/withdrawals/Lds1Purchase';
import { WithdrawalList } from './pages/withdrawals/WithdrawalList';
import { WithdrawalReports } from './pages/withdrawals/WithdrawalReports';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route element={<AppShell />}>
        <Route index element={<Dashboard />} />

        {/* Members */}
        <Route path="members">
          <Route index element={<Navigate to="/members/all" replace />} />
          {/* :filter is all | active | inactive | blocked — the list is
              server-filtered, so one page serves every tab. */}
          <Route path="wallet/:mode" element={<WalletAdjust />} />
          <Route path="virtual-power" element={<VirtualPower />} />
          <Route path="search" element={<MemberSearch />} />
          <Route path="binary-tree" element={<BinaryTree />} />
          <Route path="view/:id" element={<MemberDetail />} />
          <Route path=":filter" element={<MemberList />} />
        </Route>

        {/* Deposits */}
        <Route path="deposits">
          <Route index element={<Navigate to="/deposits/pending" replace />} />
          <Route path="blockchain" element={<BlockchainDeposits />} />
          <Route path=":status" element={<DepositList />} />
        </Route>

        {/* DApp (wallet) registration requests */}
        <Route path="dapp-requests">
          <Route index element={<Navigate to="/dapp-requests/pending" replace />} />
          <Route path=":status" element={<DappRequests />} />
        </Route>

        {/* Incomes — per-type ledger browser (Alpha One types only) */}
        <Route path="income">
          <Route index element={<Navigate to="/income/all" replace />} />
          <Route path=":type" element={<IncomeLedger />} />
        </Route>

        {/* Withdrawals */}
        <Route path="withdrawals">
          <Route index element={<Navigate to="/withdrawals/pending" replace />} />
          <Route path="reports" element={<WithdrawalReports />} />
          <Route path="auto" element={<AutoWithdrawal />} />
          <Route path="lds1-purchase" element={<Lds1Purchase />} />
          <Route path=":status" element={<WithdrawalList />} />
        </Route>

        {/* Support */}
        <Route path="tickets" element={<TicketList />} />
        <Route path="tickets/:id" element={<TicketDetail />} />

        {/* Packages */}
        <Route path="packages" element={<PackageManagement />} />

        {/* System */}
        <Route path="system">
          <Route index element={<Navigate to="/system/settings" replace />} />
          <Route path="news" element={<News />} />
          <Route path="settings" element={<SystemSettings />} />
          <Route path="cron-log" element={<CronMonitor />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
